// This icon file is generated automatically.
var PManOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.66.88H8.72a.1.1 0 00-.1.09v.87c0 .06.05.1.1.1h2.5l-3.1 3.11a4.46 4.46 0 00-5.93.4 4.48 4.48 0 000 6.36 4.47 4.47 0 006.37 0 4.47 4.47 0 00.39-5.92l3.11-3.11v2.5c0 .05.04.1.1.1h.87a.1.1 0 00.1-.1V1.34a.47.47 0 00-.47-.47zM5.37 11.94a3.32 3.32 0 11.01-6.63 3.32 3.32 0 010 6.63z", "fill-rule": "nonzero" } }] }, "name": "p-man", "theme": "outlined" };
export default PManOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PManOutlined.js
// module id = 3500
// module chunks = 0